import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Subheader, Paper, CircularProgress } from 'material-ui';
import { filter, isEmpty, get, map } from 'lodash';
import moment from 'moment';

import PanelMessage from 'components/panels/PanelMessage';
import { fetchEmployeeUnionData } from 'actions/EmployeePensionAndUnion';
import styles from './styles/Cards';
import { renderUnionRow } from './helpers';

const EmployeeUnion = ({
  fetchEmployeeUnion,
  employeeUnions,
  employeeUnionLoading,
  employeeUnionError,
  detailId,
}) => {
  useEffect(() => {
    fetchEmployeeUnion(detailId);
  }, []);

  const valid = filter(employeeUnions, u => moment().isBetween(moment(u.Begda), moment(u.Endda)));
  const latest = valid[0];
  const history = filter(valid, p => p.EmployeeDetailUnionID !== get(latest, 'EmployeeDetailUnionID'));

  if (employeeUnionLoading) return <Paper style={styles.loading}><CircularProgress /></Paper>;

  if (employeeUnionError) {
    return (<PanelMessage
      type="error"
      iconName="error"
      zDepth={1}
      message={employeeUnionError.Message || <FormattedMessage id="error" values={{ name: <FormattedMessage id="EmployeeUnion" /> }} />}
    />);
  }

  const renderList = () => (
    <Paper>
      {renderUnionRow(latest)}
      {map(history, u => renderUnionRow(u))}
    </Paper>
  );

  return (
    <React.Fragment>
      <Subheader style={styles.subheader}><FormattedMessage id="EmployeeUnion" /></Subheader>
      {!isEmpty(latest)
        ? renderList()
        : <PanelMessage
          zDepth={1}
          message={<FormattedMessage id="No.employee.union" />}
          iconName="info"
          type="info"
        />
      }
    </React.Fragment>
  );
};

EmployeeUnion.propTypes = {
  fetchEmployeeUnion: PropTypes.func,
  employeeUnions: PropTypes.array,
  employeeUnionLoading: PropTypes.bool,
  employeeUnionError: PropTypes.object,
  detailId: PropTypes.number,
};

const mapStateToProps = ({ EmployeePensionAndUnionReducer }) =>
  ({
    employeeUnions: EmployeePensionAndUnionReducer.employeeUnions,
    employeeUnionLoading: EmployeePensionAndUnionReducer.employeeUnionLoading,
    employeeUnionError: EmployeePensionAndUnionReducer.employeeUnionError,
  });

const mapDispatchToProps = dispatch => ({
  fetchEmployeeUnion: detailId => dispatch(fetchEmployeeUnionData(detailId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeUnion);



// WEBPACK FOOTER //
// ./src/containers/pay/EmployeeUnion.js